import invariant from 'tiny-invariant'

import { useSessionMetadata } from './useSessionMetadata'

export function useSessionMetadataOrFail() {
  const sessionMetadata = useSessionMetadata()

  invariant(sessionMetadata, 'Expected sessionMetadata to be defined')

  return sessionMetadata
}
